import { ServerEnv } from 'Configs/ServerEnv'
import httpHelper from 'Services/HttpHelper'

const getCenturion = async ({ baId, period, countryCode, token }) => {
    const url = `${ServerEnv.MemberCalls2()}/etlV2/centurion`
    const qs = {
        baId,
        period,
        countryCode
    }
    return httpHelper.Get({ url, config: { params: qs, headers: { 'authorization-hydra': `Bearer ${token}` } } })
}

const getLeg3Hc = async ({ baId, period, rank, ushopCountryCode, token }) => {
    const url = `${ServerEnv.MemberCalls2()}/etlV2/leg3Hc`
    const qs = {
        period,
        rank,
        baId,
        ushopCountryCode
    }
    return httpHelper.Get({ url, config: { params: qs, headers: { 'authorization-hydra': `Bearer ${token}` } } })
}

export const AchievementAPI = {
    getCenturion,
    getLeg3Hc
}
